<template>
  <div class="monthly-saving-insight-popup">
    <insight-details-popup
                      :cashflow-category="cashflowCategory"
                      :insight="insight"
                      :buttons="buttons"
                      :showFeedbackFooter="false"
                      :close-action="closeAction" >
      <template v-slot:top-content>
        <div class="insight-header">
          אפשר לחסוך כל חודש
          <span v-if="insight.hasSavingEnvelope">עוד</span>
          <div class="amount">{{ formattedAmount }} ₪</div>
        </div>
      </template>
      <template v-slot:bottom-content>

        <div class="insight-content">
          <div v-if="!insight.hasSavingEnvelope">
            לפי הניתוח של המערכת, נראה שיש לך אפשרות להעביר כסף לחיסכון באופן קבוע כל חודש.
          </div>
          <div v-else>
            לפי הניתוח של המערכת, יש לך חיסכון חודשי
            <span class="pink-font">(כל הכבוד!)</span>
            ונראה שאפשר להעביר עוד כסף כל חודש.
          </div>
        </div>

        <div class="insight-content">
          נרשמת לרייזאפ עם הטבה
          <span class="title">מחברת הראל</span>,
          יש לך הזדמנות לחסוך אצלם בקופת גמל להשקעה.
        </div>

        <callout iconPath="icons/heart-icon.svg" title="טיפ מאיתנו" class="insight-callout">
          <template v-slot:text>
           <div v-if="!insight.hasSavingEnvelope">זו הזדמנות מעולה ליצור הוראת קבע לחיסכון. ככה כל חודש יתחיל קודם כל עם מתנה לעצמך!</div>
           <div v-else> אם לא מתאים לך כרגע להגדיל את הסכום החודשי לחיסכון, אפשר גם לעשות הפקדה חד פעמית.</div>
          </template>
        </callout>
      </template>
    </insight-details-popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import moneyUtils from '@/utils/money';
import InsightDetailsPopup from '../InsightDetailsPopup';

export default {
  name: 'HarelMonthlySavingPopup',
  components: {
    Callout: BaseUI.Callout,
    InsightDetailsPopup,
  },
  props: {
    insight: { type: Object, require: true },
    cashflowCategory: { type: String, required: true },
    buttons: { type: Array, required: false },
    closeAction: { type: Function, required: true },
  },
  created() {
    Segment.trackUserGot('HarelMonthlySavingPopupLoaded', this.insight);
  },
  computed: {
    formattedAmount() {
      return moneyUtils.formatAmountWithFraction(this.insight.proposedMonthlySavingAmount, 0);
    },
  },
};

</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';

  .monthly-saving-insight-popup {
    text-align: right;

    .insight-header {
      color: $riseup_white;
      font-size: 16px;
      text-align: right;

      .amount {
        font-size: 46px;
        font-weight: bold;
        margin-top: 10px;
      }
    }

    .insight-content {
      text-align: right;
      font-size: 22px;
      margin-bottom: 28px;

      .pink-font {
        color: $riseup_red;
        font-weight: bold;
      }

      .title {
        font-weight: bold;
      }
    }
  }

</style>
